export default __webpack_public_path__ + "static/media/policy_yanzhen.8ce0b101.png";